const icon = {
    url: 'https://sitewise.tetrad.com/appskin/3.2.0/4/images/marker_red_red_dot.png',
    anchor: new window.google.maps.Point(12, 28)
};

export default icon;
